import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Loading from "../Loading";
import {useTheme} from "@mui/material/styles";
import {CgSpinner} from "react-icons/cg";

interface MuiFetchingSpinnerProps {
    text: string;
}

const MuiFetchingSpinner: React.FC<MuiFetchingSpinnerProps> = ({text}) => {
    const theme = useTheme();

    return (
        <Box
            sx={{
                position: 'fixed',
                top: '16px',
                right: '20px',
                mt: '2',
                mr: '6',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-center',
                zIndex: 9999,
            }}
        >
            <Typography variant="body2" fontStyle="italic" fontSize="small"
                        sx={{
                            color: 'white',
                            bgcolor: 'transparent',
                        }}>
                {text}
            </Typography>
            <Box sx={{
                display: 'flex', justifyContent: 'center', color: 'white',
                bgcolor: 'transparent',
            }}>
                {<CgSpinner className="animate-spin"/>}
            </Box>
        </Box>
    );
};

export default MuiFetchingSpinner;
